import { View } from 'components/View'
import React from 'react'
import './index.scss'

export default function Hoverable ({
  isDisabled,
  ...props
}) {
  return (
    <View className={!props.isDisabled && 'hoverable'} {...props} />
  )
}
